// src/components/InstitutionCounter.js
import React, { useState, useRef, useEffect } from 'react';
import CountUp from 'react-countup';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import GroupIcon from '@mui/icons-material/Group';
import { styled } from '@mui/system';
import CenteredTitle from './CenteredTitle';

/* -------------------- Estilos 3D / Premium -------------------- */
const Section = styled(Box)({
  position: 'relative',
  padding: '56px 18px',
  background:
    'radial-gradient(1200px 500px at 10% -10%, rgba(218,165,32,.08), rgba(0,0,0,0)),' +
    'linear-gradient(180deg, #0F1115 0%, #12151B 60%, #141821 100%)',
});

const Glow = styled('div')({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  background:
    'radial-gradient(500px 160px at 80% 0%, rgba(218,165,32,.18), rgba(0,0,0,0))',
  filter: 'blur(30px)',
  opacity: 0.7,
});

const StatCard = styled(Card)({
  minWidth: 280,
  textAlign: 'center',
  borderRadius: 18,
  overflow: 'hidden',
  background:
    'linear-gradient(180deg, rgba(255,255,255,.06) 0%, rgba(255,255,255,.03) 100%)',
  border: '1px solid rgba(255,255,255,.10)',
  boxShadow:
    '0 1px 0 rgba(255,255,255,.12) inset, 0 14px 26px rgba(0,0,0,.45), 0 60px 120px rgba(0,0,0,.35)',
  transform: 'translateZ(0)',
  transition: 'transform .22s ease, box-shadow .28s ease, border-color .28s ease',
  '&:hover': {
    transform: 'translateY(-6px) scale(1.01)',
    boxShadow:
      '0 1px 0 rgba(255,255,255,.14) inset, 0 22px 42px rgba(0,0,0,.55), 0 100px 160px rgba(0,0,0,.38)',
    borderColor: 'rgba(218,165,32,.35)',
  },
});

const IconBadge = styled('div')({
  width: 72,
  height: 72,
  margin: '0 auto 14px',
  borderRadius: '50%',
  display: 'grid',
  placeItems: 'center',
  background:
    'linear-gradient(180deg, rgba(218,165,32,.22) 0%, rgba(218,165,32,.08) 100%)',
  border: '1px solid rgba(218,165,32,.45)',
  boxShadow:
    '0 10px 20px rgba(218,165,32,.35), inset 0 1px 0 rgba(255,255,255,.25)',
});

const Label = styled(Typography)({
  letterSpacing: '.08em',
  fontWeight: 900,
  color: '#F5DEB3',
});

const Number = styled(Typography)({
  fontSize: '3rem',
  lineHeight: 1.05,
  fontWeight: 900,
  color: '#fff',
  textShadow: '0 1px 0 rgba(0,0,0,.45)',
});

const Sub = styled(Typography)({
  color: 'rgba(255,255,255,.78)',
  fontWeight: 700,
  letterSpacing: '.04em',
});

/* -------------------- Componente -------------------- */
const ExperienciaCounter = () => {
  const [startCount, setStartCount] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const node = counterRef.current;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setStartCount(true);
          obs.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (node) obs.observe(node);
    return () => node && obs.unobserve(node);
  }, []);

  return (
    <Section ref={counterRef}>
      <Glow />
      <CenteredTitle title="Trayectoria" className="custom-title" />

      <Grid container spacing={3} justifyContent="center">
        {/* EXPERIENCIA */}
        <Grid item>
          <StatCard>
            <CardContent sx={{ py: 4, px: 4 }}>
              <IconBadge>
                <WorkIcon sx={{ fontSize: 38, color: '#EABE2a' }} />
              </IconBadge>

              <Label variant="overline">EXPERIENCIA</Label>

              <Number component="div" aria-label="Años de experiencia">
                +
                {startCount ? (
                  <CountUp end={30} duration={2.2} separator="." />
                ) : (
                  0
                )}
              </Number>

              <Sub variant="subtitle2">AÑOS</Sub>
            </CardContent>
          </StatCard>
        </Grid>

        {/* CLIENTES */}
        <Grid item>
          <StatCard>
            <CardContent sx={{ py: 4, px: 4 }}>
              <IconBadge>
                <GroupIcon sx={{ fontSize: 38, color: '#EABE2a' }} />
              </IconBadge>

              <Label variant="overline">CLIENTES</Label>

              <Number component="div" aria-label="Clientes atendidos">
                +
                {startCount ? (
                  <CountUp end={15400} duration={2.2} separator="." />
                ) : (
                  0
                )}
              </Number>

              <Sub variant="subtitle2">SATISFECHOS</Sub>
            </CardContent>
          </StatCard>
        </Grid>
      </Grid>
    </Section>
  );
};

export default ExperienciaCounter;
